var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoteExpertDecisionsMobileIcon7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 42,
    viewBox: "0 0 25 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.91634 27.25C12.2175 27.25 14.083 29.1155 14.083 31.4167C14.083 33.7179 12.2175 35.5833 9.91634 35.5833C7.61515 35.5833 5.74967 33.7179 5.74967 31.4167C5.74967 29.1155 7.61515 27.25 9.91634 27.25ZM9.91634 27.25V12.6667M18.2497 8.5H24.4997M18.2497 12.6667H24.4997M18.2497 16.8333H24.4997M18.2497 21H24.4997M9.91634 2.25C12.2175 2.25 14.083 4.11548 14.083 6.41667L14.0853 24.1995C16.5749 25.6407 18.2497 28.3331 18.2497 31.4167C18.2497 36.019 14.5187 39.75 9.91634 39.75C5.31397 39.75 1.58301 36.019 1.58301 31.4167C1.58301 28.3323 3.25872 25.6392 5.74942 24.1983L5.74967 6.41667C5.74967 4.11548 7.61515 2.25 9.91634 2.25Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteExpertDecisionsMobileIcon7);
export default __webpack_public_path__ + "static/media/note-expert-decisions-mobile-icon7.9a651b9fd363cbf34cda67f39f9577f0.svg";
export { ForwardRef as ReactComponent };